import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const quickCategories = categories.slice(0, 7);
  const moreCategories = categories.slice(7);

  return (
    <footer className="relative bg-foreground-900 rounded-t-2xl mx-4 md:mx-6 mt-8">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-flex items-center gap-2">
              <span className="text-xl font-heading font-bold tracking-tight text-background-50">
                Kakobuy<span className="text-primary-400">Sheet</span>
              </span>
            </Link>
            <p className="mt-3 text-sm text-background-300 leading-relaxed max-w-xs">
              Your trusted resource for the latest Kakobuy Spreadsheet links, product finds, and shopping guides — updated daily.
            </p>
          </div>

          {/* Quick Categories 1 */}
          <div>
            <h4 className="text-xs font-semibold text-background-50 uppercase tracking-wider mb-4">Top Categories</h4>
            <ul className="space-y-2.5">
              {quickCategories.map((cat) => (
                <li key={cat.slug}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Categories 2 */}
          <div>
            <h4 className="text-xs font-semibold text-background-50 uppercase tracking-wider mb-4">More Categories</h4>
            <ul className="space-y-2.5">
              {moreCategories.map((cat) => (
                <li key={cat.slug}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-xs font-semibold text-background-50 uppercase tracking-wider mb-4">Resources</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="text-sm text-background-300 hover:text-primary-400 transition-colors">Contact</Link></li>
              <li><Link to="/privacy" className="text-sm text-background-300 hover:text-primary-400 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/disclaimer" className="text-sm text-background-300 hover:text-primary-400 transition-colors">Disclaimer</Link></li>
              <li><Link to="/terms" className="text-sm text-background-300 hover:text-primary-400 transition-colors">Terms</Link></li>
              <li><Link to="/articles/kakobuy-spreadsheet-guide" className="text-sm text-background-300 hover:text-primary-400 transition-colors">SEO Guide</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-10 md:mt-14 pt-6 border-t border-background-200/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} KakobuySheet. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">
              Kakobuy Spreadsheet
            </a>
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">
              Buy It Now
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}